import { render, staticRenderFns } from "./add-group-user-modal.vue?vue&type=template&id=35ff2e76&"
import script from "./add-group-user-modal.vue?vue&type=script&lang=js&"
export * from "./add-group-user-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports